import * as React from "react";
import { inject, observer } from "mobx-react";
import { RouterStore } from "mobx-react-router";
import AccountService from "../../service/AccountService";
import { styled } from "@mui/material/styles";
import "antd/dist/antd.css";
import { Form, Input, InputGroup, RadioGroup, Radio } from "rsuite";
import {
  Paper,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Button,
  Snackbar,
  CircularProgress,
  TableContainer,
  TableHead,
  TableBody,
  Table,
  TableCell,
  TableRow,
  TableSortLabel,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Box,
} from "@mui/material";
import LogoutButton from "../common/LogoutButton";
import BackIcon from "@mui/icons-material/ArrowBack";
import autobind from "autobind-decorator";
import AddIcon from "@mui/icons-material/Add";
import { observable } from "mobx";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import Pagination from "@mui/material/Pagination";
import ContactService, {
  TemplateData,
  TemplateResult,
} from "../../service/ContactService";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import "react-phone-input-2/lib/style.css";
import { checkEmpty } from "../../util/util";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import FileService from "../../service/FileService";
import ClearIcon from "@mui/icons-material/Clear";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import RenderCustomElement from "../contact/components/RenderCustomElement";
import moment from "moment";
import { withStyles } from "@mui/styles";
import { emailTemplateForm, smsTemplateForm } from "./TemplatesForm";
import { isEmpty } from "lodash";

const Alert = (props: AlertProps) => {
  return (
    <MuiAlert
      elevation={6}
      variant="filled"
      {...props}
      style={{ width: "100%" }}
    />
  );
};

const CustomHelperTextError = () => (
  <Box color="red" display="flex" alignItems="center" margin="4px 0">
    <ErrorOutlineOutlinedIcon style={{ marginRight: "4px" }} />
    <span>This field is required</span>
  </Box>
);

const CustomIconButton = styled(IconButton)({
  backgroundColor: "#4994fd",
  color: "#fff",
  margin: "0 0.5rem",
  height: "40px",
  width: "40px",
  "&:hover": {
    backgroundColor: "#4994fd",
    color: "#fff",
  },
});

export const StyledTableCell = withStyles({
  head: {
    backgroundColor: "rgb(196,196,196,.15)",
  },
})(TableCell);

export const StyledTableRow = withStyles({
  root: {
    borderBottomStyle: "solid",
    borderBottomColor: "rgb(0,0,0,0.18)",
    borderBottomWidth: "1px",
    borderTopStyle: "solid",
    borderTopColor: "rgb(0,0,0,0.18)",
    borderTopWidth: "1px",
  },
})(TableRow);

type SnackbarMessageType = "success" | "error" | "info" | "warning";

type Sort = "desc" | "asc";

export type OrderType = "name" | "subject" | "body" | "type" | "updatedAt";

export type TemplateState = "NORMAL" | "LOADING" | TemplateResult;

export type ActionType = "Add" | "Update" | "Delete";

type TemplatePageProps = {
  routing?: RouterStore;
  account?: AccountService;
  files?: FileService;
};

type TemplatePageState = {
  searchText: string;
  checkedAll: boolean;
  pageNum: number;
  sendCategory: string;
  editorState: any;
  templateType: string;
};

@inject("routing")
@inject("account")
@inject("files")
@observer
export default class TemplatePage extends React.Component<
  TemplatePageProps,
  TemplatePageState
> {
  state = {
    searchText: "",
    checkedAll: false,
    pageNum: 1,
    sendCategory: "email",
    editorState: EditorState.createEmpty(),
    templateType: "Email",
  };

  @observable
  private _contactService: ContactService = new ContactService(
    this.props.account
  );

  @observable
  private _sgTemplates = Array<TemplateData | any>();

  @observable
  private _fsTemplates = Array<TemplateData | any>();

  @observable
  private _order: Sort = "desc";

  @observable
  private _orderBy: OrderType = "updatedAt";

  @observable
  private _showTemplateModal = false;

  @observable
  private _name = "";

  @observable
  private _subject = "";

  @observable
  private _body = "";

  @observable
  private _message = "";

  @observable
  private _bodyPlainText = "";

  @observable _selectedLocations = [];

  @observable
  private _templates: Array<TemplateData | any>;

  @observable _selectedTemplate: TemplateData = null;

  @observable _selectedTemplateId: string = "";

  @observable _selectedVersionId: string = "";

  @observable
  private _status: TemplateState = "NORMAL";

  @observable
  private _checkEmptyForm: boolean = false;

  @observable
  private _showSnackbar: boolean = false;

  @observable
  private _actionType: ActionType = "Add";

  @observable
  searchText = "";

  @observable
  smsText = "";

  @observable
  sendLater: boolean = false;

  @observable
  sendAt: Date = new Date();

  @observable
  isLoading: boolean = false;

  @observable
  modalDataLoading: boolean = false;

  @observable
  dataLoading: boolean = true;

  @observable
  profilPicture: string = "";

  @autobind
  goBack() {
    this.props.account.goBack();
  }

  pageChangeHandler = (event: React.ChangeEvent<unknown>, value: number) => {
    event.preventDefault();
    window.scrollTo(0, 0);
    this.setState({ ...this.state, pageNum: value });
  };

  onEditorStateChange: Function = (editorState: any) => {
    const updatedBody = draftToHtml(
      convertToRaw(this.state.editorState.getCurrentContent())
    );
    const blocks = convertToRaw(
      this.state.editorState.getCurrentContent()
    ).blocks;
    const values = blocks.map((block: any) => block.text.trim()).join("\n");
    this._bodyPlainText = values;
    this._body = updatedBody;
    this.setState({
      ...this.state,
      editorState,
    });
  };

  @autobind
  handleNameChange(val: any) {
    this._name = val;
  }

  @autobind
  handleSubjectChange(val: any) {
    this._subject = val;
  }

  @autobind
  handleBodyChange(val: any) {
    this._body = val;
  }

  @autobind
  handleMessageChange(val: any) {
    this._message = val;
  }

  @autobind
  listToDataPicker(
    data: Array<any>,
    key: string,
    labelName: string,
    labelValue: string
  ): Array<any> {
    if (data?.length === 0) {
      return [];
    }
    return data.map((item) => {
      return {
        key: item[`${key}`],
        label: item[`${labelName}`],
        value: labelValue ? item[`${labelValue}`] : item,
      };
    });
  }

  @autobind
  async getTemplates() {
    const result = await this._contactService.getTemplates();
    if (result === "GET_SUCCESS") {
      this._sgTemplates = this._contactService.allSgTemplates;
      this._fsTemplates = this._contactService.allFsTemplates;
      this._templates = this._contactService.allFsTemplates;
    }
  }

  @autobind
  resetValues() {
    this._name = "";
    this._subject = "";
    this._body = "";
    this._selectedTemplate = null;
    this.isLoading = false;
    this.setState({
      ...this.state,
      editorState: EditorState.createEmpty(),
      templateType: "Email",
    });
  }

  @autobind
  searchedTemplates() {
    const newTemplates: any[] = this._fsTemplates.filter((template) =>
      template.name.includes(this.state.searchText)
    );
    return newTemplates;
  }

  @autobind
  htmlWrapper(content: any) {
    return `
  <div
    style="
    background-color: #e1e1e1;
    border-radius: 6px;
    align-items: center;
    padding: 2rem 1rem;
    margin: 1rem auto;"
  >
    ${
      this.profilPicture &&
      `<div style=" width: 75%; background-color: white; border-radius: 6px; padding: 2rem 1rem; margin: 1rem auto;"> <img src=${this.profilPicture} alt="" style="width: 100px; height: 100px; border-radius: 50%;display:block; margin:1rem auto"/></div>`
    }
    <div
      style="
        width: 75%;
        background-color: white;
        border-radius: 6px;
        padding: 2rem 1rem;
        margin: 1rem auto;
      "
    >
    ${content}
    </div>
  </div>`;
  }

  addTemplateHandler = async (event: any) => {
    event.preventDefault();
    let templateData: TemplateData = {
      name: this._name.trim(),
      subject: this._subject.trim(),
      html_content: this._body,
      content: this._body,
    };
    const state = checkEmpty(templateData);
    if (state) {
      this._checkEmptyForm = true;
    } else {
      const templateResult = await this._contactService.addTemplate(
        this._sgTemplates,
        templateData,
        this.state.templateType
      );
      if (templateResult === "TEMPLATE_IS_EXIST") {
        this._status = "TEMPLATE_IS_EXIST";
        this.isLoading = false;
        this._showSnackbar = true;
      } else if (templateResult === "ADD_SUCCESS") {
        this._status = "ADD_SUCCESS";
        this._showTemplateModal = false;
        this._showSnackbar = true;
        this.resetValues();
        this.getTemplates();
      } else {
        this._status = "UNKNOWN_ERROR";
        this._showTemplateModal = false;
        this._showSnackbar = true;
        this.isLoading = false;
      }
    }
  };

  updateTemplateHandler = async (event: any) => {
    event.preventDefault();
    const templateData: TemplateData = {
      name: this._name.trim(),
      subject: this._subject.trim(),
      html_content: this.htmlWrapper(this._body),
      content: this._body,
    };
    const state = checkEmpty(templateData);
    if (state) {
      this._checkEmptyForm = true;
    } else {
      const templateResult = await this._contactService.updateTemplate(
        templateData,
        this._selectedTemplateId,
        this._selectedVersionId,
        this.state.templateType
      );

      if (templateResult === "UPDATE_SUCCESS") {
        this._status = "UPDATE_SUCCESS";
        this._showTemplateModal = false;
        this._showSnackbar = true;
        this.resetValues();
        this.getTemplates();
      } else {
        this._status = "UNKNOWN_ERROR";
        this._showTemplateModal = false;
        this._showSnackbar = true;
        this.isLoading = false;
      }
    }
  };

  deleteTemplateHandler = async (event: any) => {
    event.preventDefault();
    const result = await this._contactService.deleteTemplate(
      this._selectedTemplateId,
      this._selectedVersionId
    );
    this._showTemplateModal = false;
    if (result === "DELETE_SUCCESS") {
      this._status = "DELETE_SUCCESS";
      this._showSnackbar = true;
      this.resetValues();
      this.getTemplates();
    } else {
      this._status = "UNKNOWN_ERROR";
      this._showTemplateModal = false;
      this._showSnackbar = true;
      this.isLoading = false;
    }
  };

  @autobind
  async getTemplateInfo(templateId: string) {
    const template = await this._contactService.getTemplate(templateId);
    const tempContent = template.content;
    const result = this._sgTemplates.filter(
      (temp) => temp.template_id === templateId
    );
    this._selectedTemplate = result[0];
    this._name = this._selectedTemplate.name;
    this._subject = this._selectedTemplate.subject;
    this._body = tempContent;
    const contentBlock = htmlToDraft(tempContent);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      const editorState = EditorState.createWithContent(contentState);
      this.setState({
        ...this.state,
        editorState,
      });
    }
  }

  @autobind
  handleTemplateTypeChange(name: string, value: string) {
    this.setState({ ...this.state, [name]: value });
  }

  handleRequestSort(property: OrderType) {
    const isAsc = this._orderBy === property && this._order === "asc";
    this._order = isAsc ? "desc" : "asc";
    this._orderBy = property;

    if (this._order === "asc") {
      this._templates = this.searchedTemplates().sort((itemA, itemB) =>
        itemA?.[property] > itemB?.[property]
          ? 1
          : itemA?.[property] < itemB?.[property]
          ? -1
          : 0
      );
    } else if (this._order === "desc") {
      this._templates = this.searchedTemplates().sort((itemA, itemB) =>
        itemA?.[property] > itemB?.[property]
          ? -1
          : itemA?.[property] < itemB?.[property]
          ? 1
          : 0
      );
    }
  }

  async componentDidMount() {
    await this.getTemplates();
    if (this.props.account.userData.displayPic) {
      this.profilPicture = this.props.account.userData.displayPic;
    }
    this.dataLoading = false;
  }

  async componentDidUpdate(
    _: Readonly<TemplatePageProps>,
    prevState: Readonly<{ searchText: string }>
  ) {
    if (prevState.searchText != this.state.searchText) {
      this._templates = this.searchedTemplates();
    }
  }

  renderNavBar() {
    return (
      <AppBar position="static">
        <Toolbar variant="dense">
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={this.goBack}
          >
            <BackIcon />
          </IconButton>
          <Typography variant="h6" style={{ flexGrow: 1, color: "inherit" }}>
            Templates
          </Typography>
          <LogoutButton />
        </Toolbar>
      </AppBar>
    );
  }

  renderSearchBar() {
    return (
      <Paper style={{ margin: "1rem" }}>
        <Box
          display="flex"
          columnGap="40px"
          justifyContent="space-between"
          alignItems="center"
          padding="1.5rem 2.5rem"
        >
          <InputGroup style={{ width: "400px" }}>
            <Input
              placeholder="Search Template"
              onChange={(val: any) =>
                this.setState({ ...this.state, searchText: val })
              }
              value={this.state.searchText}
            />
            <InputGroup.Addon>
              <SearchIcon />
            </InputGroup.Addon>
          </InputGroup>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              this._showTemplateModal = true;
              this._actionType = "Add";
            }}
            size="medium"
            style={{ height: "40px" }}
          >
            <AddIcon style={{ marginRight: "0.6rem" }} />
            Add Template
          </Button>
        </Box>
      </Paper>
    );
  }

  renderTemplatesTable() {
    return (
      <Paper style={{ margin: "1rem" }}>
        <TableContainer component={Paper} style={{ marginBottom: "20px" }}>
          <Table>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell
                  align="left"
                  sortDirection={this._orderBy === "name" ? this._order : "asc"}
                >
                  <TableSortLabel
                    active={this._orderBy === "name"}
                    direction={this._orderBy === "name" ? this._order : "asc"}
                    onClick={() => this.handleRequestSort("name")}
                    style={{ minWidth: "200px" }}
                  >
                    Template Name
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell align="left">
                  <TableSortLabel
                    active={this._orderBy === "subject"}
                    direction={
                      this._orderBy === "subject" ? this._order : "asc"
                    }
                    onClick={() => this.handleRequestSort("subject")}
                    style={{ minWidth: "250px" }}
                  >
                    Template Subject
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell>
                  <TableSortLabel
                    active={this._orderBy === "type"}
                    direction={this._orderBy === "type" ? this._order : "asc"}
                    onClick={() => this.handleRequestSort("type")}
                    style={{ width: "150px" }}
                  >
                    Template Type
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <TableSortLabel
                    active={this._orderBy === "updatedAt"}
                    direction={
                      this._orderBy === "updatedAt" ? this._order : "asc"
                    }
                    onClick={() => this.handleRequestSort("updatedAt")}
                    style={{ width: "120px" }}
                  >
                    Updated At
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell align="center">Actions</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {this._templates?.length > 0 &&
                this._templates.map((template, index) => (
                  <StyledTableRow key={`${template.versionId}`}>
                    <TableCell>{template.name}</TableCell>
                    <TableCell>{template.subject}</TableCell>
                    <TableCell>{template.type}</TableCell>
                    <TableCell align="center">
                      {moment(template.updatedAt).format("MM-DD-YYYY")}
                    </TableCell>
                    <TableCell align="center">
                      <CustomIconButton
                        onClick={async () => {
                          this._selectedTemplateId = template.templateId;
                          this._selectedVersionId = template.versionId;
                          this._actionType = "Update";
                          this._showTemplateModal = true;
                          this.setState({
                            ...this.state,
                            templateType: template.type,
                          });
                          await this.getTemplateInfo(template.templateId);
                        }}
                      >
                        <EditIcon />
                      </CustomIconButton>
                      {
                        // this._deletingUser?.uid == template.uid
                        false ? (
                          <CircularProgress size={18} />
                        ) : (
                          <CustomIconButton
                            edge="end"
                            aria-label="delete"
                            // disabled={this._deletingUser != null}
                            onClick={() => {
                              this._selectedTemplateId = template.templateId;
                              this._selectedVersionId = template.versionId;
                              this._showTemplateModal = true;
                              this._actionType = "Delete";
                            }}
                          >
                            <DeleteIcon />
                          </CustomIconButton>
                        )
                      }
                    </TableCell>
                  </StyledTableRow>
                ))}
            </TableBody>
          </Table>
          {this.searchedTemplates().length > 0 && (
            <Pagination
              count={Math.trunc(this.searchedTemplates().length / 25 + 1)}
              color="primary"
              style={{
                margin: "20px auto",
                width: "fit-content",
              }}
              onChange={this.pageChangeHandler}
            />
          )}
        </TableContainer>
      </Paper>
    );
  }

  renderTemplateModal(type: ActionType) {
    const smsInputData = {
      fields: [
        {
          name: "Name",
          type: "input",
          value: this._name,
          onChange: this.handleNameChange,
          fieldStatus: this._status,
        },
        {
          name: "Subject",
          type: "input",
          value: this._subject,
          onChange: this.handleSubjectChange,
          fieldStatus: this._status,
        },
        {
          name: "Text Message",
          type: "textarea",
          value: this._body,
          onChange: this.handleBodyChange,
          fieldStatus: this._status,
        },
      ],
      checkEmptyForm: this._checkEmptyForm,
    };

    const emailInputData = {
      fields: [
        {
          name: "Name",
          value: this._name,
          onChange: this.handleNameChange,
          fieldStatus: this._status,
        },
        {
          name: "Subject",
          value: this._subject,
          onChange: this.handleSubjectChange,
          fieldStatus: this._status,
        },
      ],
      editorState: this.state.editorState,
      handleEditorChange: this.onEditorStateChange,
      editorBody: this._body,
      checkEmptyForm: this._checkEmptyForm,
    };
    return (
      <Dialog
        open={this._showTemplateModal}
        style={{
          marginTop: "60px",
          maxWidth: "800px !important",
        }}
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            {type === "Update" ? (
              <span>{`${type} ${this.state.templateType} Template`}</span>
            ) : (
              <span>{`${type} Template`}</span>
            )}
            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                this._showTemplateModal = false;
                this.resetValues();
              }}
            >
              <ClearIcon />
            </span>
          </Box>
        </DialogTitle>
        <DialogContent style={{ padding: "0" }}>
          {isEmpty(this._selectedTemplate) && type === "Update" ? (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              minHeight="400px"
              width="800px"
            >
              <CircularProgress size={36} style={{ margin: "auto" }} />
            </Box>
          ) : (
            <>
              {type === "Delete" ? (
                <Typography
                  padding="1rem 2rem"
                  fontSize="1.3rem"
                  marginTop="1.5rem"
                >
                  Are you sure you want to delete the template ?
                </Typography>
              ) : (
                <Form
                  style={{
                    padding: "1.5rem 2rem",
                    width: "800px",
                  }}
                >
                  {type === "Add" && (
                    <RadioGroup
                      inline
                      name="templateType"
                      value={this.state.templateType}
                      onChange={(value: string) => {
                        this.handleTemplateTypeChange("templateType", value);
                      }}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Radio value="Email">Email template</Radio>
                      <Radio value="SMS">SMS template</Radio>
                    </RadioGroup>
                  )}

                  {this.state.templateType === "Email"
                    ? emailTemplateForm(emailInputData)
                    : smsTemplateForm(smsInputData)}
                </Form>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions
          style={{
            padding: "1.5rem 1rem",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            color="inherit"
            onClick={() => {
              this._showTemplateModal = false;
              setTimeout(() => {
                this.resetValues();
              });
            }}
            size="medium"
            disabled={this.isLoading}
            style={{ height: "40px", margin: "0 1rem" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={(event) => {
              this.isLoading = true;
              type === "Add" && this.addTemplateHandler(event);
              type === "Update" && this.updateTemplateHandler(event);
              type === "Delete" && this.deleteTemplateHandler(event);
            }}
            size="medium"
            disabled={this.isLoading}
            style={{ height: "40px", margin: "0 1rem" }}
          >
            {this.isLoading ? (
              <CircularProgress size={18} style={{ color: "inherit" }} />
            ) : (
              `${type} Template`
            )}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderSnackbar(status: string) {
    let message = "";
    let messageType: SnackbarMessageType = "success";
    switch (status) {
      case "TEMPLATE_IS_EXIST":
        message = "Template already exists";
        messageType = "error";
        break;
      case "ADD_SUCCESS":
        message = "Template added successfully";
        break;
      case "UPDATE_SUCCESS":
        message = "Template updated successfully";
        break;
      case "DELETE_SUCCESS":
        message = "Template deleted successfully";
        break;
      case "EMPTY_SELECTED_TEMPLATES":
        message = "No template is selected";
        messageType = "error";
        break;
    }

    return (
      <Snackbar
        open={this._showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          this._showSnackbar = false;
          this._status = "NORMAL";
        }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box>{message && <Alert severity={messageType}>{message}</Alert>}</Box>
      </Snackbar>
    );
  }

  render() {
    return (
      <React.Fragment>
        <Box width="100%" height="env(safe-area-inset-top)" bgcolor="#3f51b5" />
        {this.renderNavBar()}
        {this.renderSearchBar()}
        {this.dataLoading ? (
          <Box display="flex" flexDirection="column" alignItems="center">
            <CircularProgress size={36} style={{ marginTop: "4rem" }} />
          </Box>
        ) : (
          this.renderTemplatesTable()
        )}
        {this.renderTemplateModal(this._actionType)}
        {this.renderSnackbar(this._status)}
      </React.Fragment>
    );
  }
}
